// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y74F","right":"styles_right__2mYBu"};